module.exports = {
    SERVER_DOMAIN: {
        VIDEO_PLAYER_DOMAIN: "https://web-public-viewer-video-dev.wjthinkbig.com",
        // 뷰어가 부모 프레임의 location 을 읽어 same-origin 이어야 한다. setupProxy 의 /webviewer 로 넘긴다.
        PDF_VIEWER_DOMAIN: "",
        QST_VIEWER_DOMAIN: "/proxyEdubase",
        GW_SMARTALL_MID_DOMAIN: "https://gw-smartall-mid-dev.wjthinkbig.com",
        // GW_SMARTALL_MID_DOMAIN: "https://localhost:7525",
        // GW_SMARTALL_MID_DOMAIN: "http://gw-smartall-mid-dev.wjthinkbig-internal.com",
        SOCKET_DOMAIN: "https://socket-public-broadcast-activity-dev.wjthinkbig.com",
        SAMID_WEB_DOMAIN: "https://smartall-mid-web-dev.wjthinkbig.com",
        SAMID_WEB_DOMAIN_PATH: "https://smartall-m-dev.wjthinkbig.com", // IOS 도메인
        // GW_ALLTAB_DOMAIN: "https://gw-thinkbigstudy-dev.wjthinkbig.com",
    },

    CLASS_DETAIL_VDO_INFO: "http://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/PREVIEW/PREVIEW_CLAS_SEQ.MP4",
};
